import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DoctorModel } from '../Model/doctor.model';
import { SharedApiService } from '../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class DoctorService {

  private endpoint = 'Doctor/GetAll';

  private sharedApiService = inject(SharedApiService)

  getAll(): Observable<{ value: DoctorModel[] }> {
    return this.sharedApiService.getAll(this.endpoint);
  }
}
